import mainImg from "../../../assets/connecting-screw.webp"; 
import thumb1 from "../../../assets/connecting-screw.webp";
import thumb2 from "../../../assets/connecting-screw.webp";

import mainImgone from "../../../assets/mini-fix.png"; 
import thumb3 from "../../../assets/mini-fix.png";
import thumb4 from "../../../assets/mini-fix.png";


import mainImgtwo from "../../../assets/dowel.webp"; 
import thumb5 from "../../../assets/dowel.webp";
import thumb6 from "../../../assets/dowel.webp";

import mainImgthree from "../../../assets/roller-catch-pro.jpg"; 
import thumb7 from "../../../assets/roller-catch-pro-thumb.webp";
import thumb8 from "../../../assets/roller-catch-pro-thumb.webp";

import mainImgfour from "../../../assets/acrlic-shelf-pin.webp"; 
import thumb9 from "../../../assets/acrlic-shelf-pin.webp";
import thumb10 from "../../../assets/acrlic-shelf-pin.webp";

import mainImgfive from "../../../assets/hinge-repair.webp"; 
import thumb11 from "../../../assets/hinge-repair.webp";
import thumb12 from "../../../assets/hinge-repair.webp";

import mainImgsix from "../../../assets/traceless-nails.webp"; 
import thumb13 from "../../../assets/traceless-nails.webp";
import thumb14 from "../../../assets/traceless-nails.webp";

import mainImgseven from "../../../assets/magnet-catcher.png"; 
import thumb15 from "../../../assets/magnet-catcher.png";
import thumb16 from "../../../assets/magnet-catcher.png";

import mainImg8 from "../../../assets/pvc-push-catcher.webp"; 
import thumb17 from "../../../assets/pvc-push-catcher.webp";
import thumb18 from "../../../assets/pvc-push-catcher.webp";



import mainImg9 from "../../../assets/hanging-bracket.webp"; 
import thumb19 from "../../../assets/hanging-bracket.webp";
import thumb20 from "../../../assets/hanging-bracket.webp";

import mainImg10 from "../../../assets/shelf-screw-pin.jpg"; 
import thumb21 from "../../../assets/shelf-screw-pin.jpg";
import thumb22 from "../../../assets/shelf-screw-pin.jpg";

import mainImg11 from "../../../assets/anti-slip-mat.webp"; 
import thumb23 from "../../../assets/anti-slip-mat.webp";
import thumb24 from "../../../assets/anti-slip-mat.webp";

import mainImg12 from "../../../assets/push-catcher.webp"; 
import thumb25 from "../../../assets/push-catcher.webp";
import thumb26 from "../../../assets/push-catcher.webp";

import mainImg13 from "../../../assets/magnetcatcher.png"; 
import thumb27 from "../../../assets/magnetcatcher.png";
import thumb28 from "../../../assets/magnetcatcher.png";

import mainImg14 from "../../../assets/hinge- lamp.webp"; 
import thumb29 from "../../../assets/hinge-lamp-thumb.webp";
import thumb30 from "../../../assets/hinge- lamp.webp";

export const products = [
  
  {
    code: "7638",
    name: "CONNECTING SCREW",
    category: "drawer fitting",

    short:
      "Connecting Screw is a reliable fastening solution used in modular furniture and drawer fittings. It ensures strong and secure connections between panels, providing stability and durability. Made from high-quality metal, it is ideal for cabinets, drawers, and modular kitchen installations.",

    features: [
      "Strong and durable metal construction",
      "Ensures secure and tight connections",
      "Ideal for modular furniture and drawer fittings",
      "Corrosion-resistant finish",
      "Easy to install and use",
      "Long-lasting performance"
    ],

    /* ✅ PRICE */
    price: "₹5",
    oldPrice: "₹10",

    /* ✅ SKU + STOCK */
    sku: "7669",
    stock: "In Stock",

    /* ✅ IMAGES */
    mainImage: mainImg,
    thumbnails: [thumb1, thumb2],

    /* ✅ VIDEO */
    video: "https://www.youtube.com/embed/6GjeqWL9Fi4",

    /* ✅ LINKS */
    catalogue: "/Slimline Price List-2026.pdf",
    inquiry:
      "https://wa.me/9191919650100908?text=Connecting%20Screw%20Inquiry",

    /* ✅ SPECIFICATIONS */
    specifications: [
      { label: "Material", value: "Metal" },
      { label: "Type", value: "Connecting Screw" },
      { label: "Finish", value: "Zinc Plated" },
      { label: "Application", value: "Drawer Fitting / Furniture Assembly" }
    ],

    /* ✅ SPEC TABLE */
    specTable: [
      { item: "Connecting Screw", code: "7669", size: "5mm x 38mm", finish: "" },
      { item: "Connecting Screw", code: "7670", size: "5mm x 32mm", finish: "" },
      { item: "Connecting Screw", code: "7671", size: "5mm x 27mm", finish: "" },
      { item: "Connecting Screw", code: "7672", size: "5mm x 22mm", finish: "" },
    ],

    /* ✅ FAQ */
    faq: [
      {
        question: "What is a Connecting Screw?",
        answer: "It is a fastening component used to securely join panels in furniture and drawers."
      },
      {
        question: "Where can it be used?",
        answer: "It is used in modular furniture, cabinets, and drawer fittings."
      },
      {
        question: "Is it durable?",
        answer: "Yes, it is made from high-quality metal for long-lasting use."
      },
      {
        question: "Is it easy to install?",
        answer: "Yes, it can be easily installed using basic tools."
      },
      {
        question: "What is its purpose?",
        answer: "It provides strong and stable connections between components."
      }
    ]
  },


  
  
  {
  code: "7381",
  name: "MINI FIX",
  category: "drawer fitting",

  short:
    "Mini Fix is a compact and reliable fastening solution for modular furniture, cabinets, and storage units. It ensures strong and precise connections between panels, providing stability and long-lasting performance. Ideal for modern furniture assemblies like kitchens, wardrobes, and cabinets.",

  features: [
    "Compact and precise fastening solution",
    "Strong and durable construction",
    "Ensures stable and secure connections",
    "Easy to install and maintain",
    "Ideal for modular furniture and cabinets",
    "Long-lasting performance"
  ],

  /* ✅ PRICE */
  price: "₹9",
  oldPrice: "₹15",

  /* ✅ SKU + STOCK */
  sku: "7668",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgone,
  thumbnails: [thumb3, thumb4],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91919650100908?text=Mini%20Fix%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal" },
    { label: "Type", value: "Mini Fix Connector" },
    { label: "Finish", value: "Zinc Plated" },
    { label: "Application", value: "Furniture / Cabinet Assembly" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Mini Fix", code: "7668", size: "3Pec/Set", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Mini Fix?",
      answer:
        "It is a compact fastening solution used to join and secure components in modular furniture and cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is ideal for kitchens, wardrobes, cabinets, and other modular furniture assemblies."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed using standard tools."
    },
    {
      question: "What is its purpose?",
      answer:
        "It provides strong and precise connections between furniture components."
    }
  ]
},
  


  {
  code: "7644",
  name: "WOODEN DOWEL",
  category: "drawer fitting",

  short:
    "Wooden Dowel is a simple and essential joining component used in modular furniture and cabinet assembly. Made from high-quality durable wood, it ensures proper alignment and strong connections between panels, providing stability and long-lasting performance.",

  features: [
    "Made from high-quality durable wood",
    "Provides accurate alignment between panels",
    "Strong and reliable connection",
    "Easy to install without special tools",
    "Improves structural strength of furniture",
    "Reusable and long-lasting"
  ],

  /* ✅ PRICE */
  price: "₹1",
  oldPrice: "₹5",

  /* ✅ SKU + STOCK */
  sku: "7666",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgtwo,
  thumbnails: [thumb5, thumb6],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/9191919650100908?text=Wooden%20Dowel%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Wood" },
    { label: "Type", value: "Dowel Pin" },
    { label: "Finish", value: "Natural Wood" },
    { label: "Application", value: "Furniture Assembly / Drawer Fitting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Wooden Dowel", code: "7666", size: "", finish: "Wood" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Wooden Dowel?",
      answer:
        "It is a wooden pin used to align and connect panels in furniture assembly."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for kitchens, wardrobes, cabinets, and modular furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality wood for long-lasting performance."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily inserted into pre-drilled holes."
    },
    {
      question: "What is its purpose?",
      answer:
        "It ensures proper alignment and strong connections in furniture."
    }
  ]
},
  
//   {
//   code: "7126",
//   name: "10\" SOFT PRO SPRING SOFT CLOSE",
//   category: "drawer fitting",

//   short:
//     "10\" Soft Pro Spring Soft Close is a high-quality spring mechanism designed for smooth and controlled closing of drawers and cabinet systems. It provides a soft close effect that reduces noise, prevents slamming, and enhances the durability of furniture. Ideal for modular kitchens, wardrobes, and modern furniture setups.",

//   features: [
//     "Soft close mechanism for smooth and silent operation",
//     "Prevents hard closing and damage to drawers",
//     "Durable and long-lasting spring construction",
//     "Ensures controlled and stable movement",
//     "Ideal for modular kitchen and furniture use",
//     "Easy to install and maintain"
//   ],

//   /* ✅ PRICE */
//   price: "₹281",
//   oldPrice: "₹380",

//   /* ✅ SKU + STOCK */
//   sku: "7673",
//   stock: "In Stock",

//   /* ✅ IMAGES */
//   mainImage: mainImgthree,
//   thumbnails: [thumb7, thumb8],

//   /* ✅ VIDEO */
//   video: "https://www.youtube.com/embed/2Py1jFLG67U",

//   /* ✅ LINKS */
//   catalogue: "/Slimline Price List-2026.pdf",
//   inquiry:
//     "https://wa.me/91919650100908?text=Soft%20Pro%20Spring%20Inquiry",

//   /* ✅ SPECIFICATIONS */
//   specifications: [
//     { label: "Material", value: "Metal" },
//     { label: "Type", value: "Soft Close Spring" },
//     { label: "Size", value: "10 Inch" },
//     { label: "Application", value: "Drawer Fitting / Cabinet System" }
//   ],

//   /* ✅ SPEC TABLE */
//   specTable: [
//     { item: "Soft Pro Spring", code: "7673", size: "50N - 5Kgs ", finish: "Metal" },
//      { item: "Soft Pro Spring", code: "7674", size: "100N - 10Kgs", finish: "Metal" },
//       { item: "Soft Pro Spring", code: "7675", size: "150N - 15Kgs", finish: "Metal" },
//        { item: "Soft Pro Spring", code: "7676", size: "200N - 20Kgs", finish: "Metal" },
//         { item: "Soft Pro Spring", code: "7677", size: "250N - 20Kgs", finish: "Metal" },
//   ],

//   /* ✅ FAQ */
//   faq: [
//     {
//       question: "What is a Soft Pro Spring?",
//       answer:
//         "It is a spring mechanism used to provide soft and controlled closing in drawers and cabinets."
//     },
//     {
//       question: "Where can it be used?",
//       answer:
//         "It is used in modular kitchens, wardrobes, and furniture drawers."
//     },
//     {
//       question: "Does it reduce noise?",
//       answer:
//         "Yes, it ensures silent and smooth closing without slamming."
//     },
//     {
//       question: "Is it durable?",
//       answer:
//         "Yes, it is made from high-quality metal for long-lasting performance."
//     },
//     {
//       question: "Is it easy to install?",
//       answer:
//         "Yes, it can be easily installed in standard drawer systems."
//     }
//   ]
// },
  


{
  code: "7126",
  name: "ROLLER CATCH PRO",
  category: "drawer fitting",

  short:
    "Roller Catch Pro is a high-performance cabinet and door catch mechanism designed for smooth, secure, and silent closure. It uses a durable roller system to hold doors firmly in place while allowing easy opening. Ideal for kitchens, wardrobes, and modular furniture, it ensures reliable operation and long-lasting performance.",

  features: [
    "Roller-based mechanism for smooth and secure closure",
    "Ensures silent operation with minimal noise",
    "Strong and durable construction",
    "Prevents door misalignment and wear",
    "Ideal for cabinets, wardrobes, and modular furniture",
    "Easy to install and maintain"
  ],

  /* ✅ PRICE */
  price: "₹281",
  oldPrice: "₹380",

  /* ✅ SKU + STOCK */
  sku: "7667",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgthree,
  thumbnails: [thumb7, thumb8],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91919650100908?text=Roller%20Catch%20Pro%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Plastic Combination" },
    { label: "Type", value: "Roller Catch" },
    { label: "Finish", value: "Standard" },
    { label: "Application", value: "Cabinet / Door Fitting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Roller Catch Pro", code: "7667", size: "", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Roller Catch Pro?",
      answer:
        "It is a roller-based mechanism used for smooth and secure closing of cabinet doors."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for cabinets, wardrobes, and modular furniture."
    },
    {
      question: "Does it reduce noise?",
      answer:
        "Yes, it provides smooth and silent closing."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting use."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed using standard fittings."
    }
  ]
},
{
  code: "7127",
  name: "ACRYLIC SHELF PIN",
  category: "drawer fitting",

  short:
    "Acrylic Shelf Pin is a durable and precise support accessory designed to hold shelves securely in cabinets, wardrobes, and storage units. Made from high-quality acrylic, it offers strong support while maintaining a clean and almost invisible look. Ideal for modular kitchens, display units, and modern furniture setups.",

  features: [
    "Made from high-quality durable acrylic",
    "Provides strong and stable shelf support",
    "Corrosion-resistant and long-lasting",
    "Invisible design for clean appearance",
    "Ideal for cabinets, wardrobes, and display units",
    "Easy to install and reposition"
  ],

  /* ✅ PRICE */
  price: "₹3",
  oldPrice: "₹6",

  /* ✅ SKU + STOCK */
  sku: "7536",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgfour,
  thumbnails: [thumb9, thumb10],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91919650100908?text=Acrylic%20Shelf%20Pin%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Acrylic" },
    { label: "Type", value: "Shelf Support Pin" },
    { label: "Finish", value: "Transparent" },
    { label: "Application", value: "Cabinet / Shelf Support" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Acrylic Shelf Pin", code: "7536", size: "Standard", finish: "Transparent" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is an Acrylic Shelf Pin?",
      answer:
        "It is a support accessory used to hold shelves securely in cabinets and furniture."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is ideal for kitchens, wardrobes, display units, and modular furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality acrylic for long-lasting use."
    },
    {
      question: "Does it affect shelf appearance?",
      answer:
        "No, its transparent design maintains a clean and minimal look."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily inserted into pre-drilled holes."
    }
  ]
},
  
  
  {
  code: "7128",
  name: "HINGE REPAIR PLATE",
  category: "drawer fitting",

  short:
    "Hinge Repair Plate is a durable solution designed to reinforce or repair damaged hinge areas in cabinets, wardrobes, and modular furniture. Made from high-quality metal, it restores alignment, improves stability, and extends the life of furniture without the need for replacement.",

  features: [
    "Made from high-quality durable metal",
    "Reinforces damaged hinge areas",
    "Restores door alignment and stability",
    "Prevents further damage or loosening",
    "Ideal for cabinets, wardrobes, and furniture",
    "Easy to install with standard screws"
  ],

  /* ✅ PRICE */
  price: "₹20",
  oldPrice: "₹40",

  /* ✅ SKU + STOCK */
  sku: "7721",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgfive,
  thumbnails: [thumb11, thumb12],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91919650100908?text=Hinge%20Repair%20Plate%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal" },
    { label: "Type", value: "Hinge Repair Plate" },
    { label: "Finish", value: "Zinc / Steel" },
    { label: "Application", value: "Cabinet / Door Repair" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Hinge Repair Plate", code: "7721", size: "", finish: "Metal" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Hinge Repair Plate?",
      answer:
        "It is a metal plate used to repair or reinforce damaged hinge areas in cabinets and furniture."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for kitchens, wardrobes, cabinets, and modular furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality metal for long-lasting performance."
    },
    {
      question: "Does it restore door alignment?",
      answer:
        "Yes, it helps realign and stabilize doors effectively."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed using standard screws."
    }
  ]
},
   {
  code: "7129",
  name: "TRACELESS NAILS",
  category: "drawer fitting",

  short:
    "Traceless Nails are smart fastening solutions designed for damage-free mounting of lightweight items on walls and surfaces. They provide strong hold without leaving marks or holes, making them ideal for modern homes, modular furniture, and decorative applications.",

  features: [
    "Damage-free wall mounting solution",
    "Leaves no permanent marks or holes",
    "Strong hold for lightweight items",
    "Ideal for pictures, decorations, and small shelves",
    "Easy to install and remove",
    "Reusable and durable design"
  ],

  /* ✅ PRICE */
  price: "₹25",
  oldPrice: "₹50",

  /* ✅ SKU + STOCK */
  sku: "7665",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgsix,
  thumbnails: [thumb13, thumb14],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91919650100908?text=Traceless%20Nails%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: " Steel Pin" },
    { label: "Type", value: "Wall Mount Nail" },
    { label: "Finish", value: "MS" },
    { label: "Application", value: "Wall Mount / Light Fixtures" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Traceless Nails", code: "7665", size: "", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are Traceless Nails?",
      answer:
        "They are nails used for mounting items without damaging walls."
    },
    {
      question: "Where can they be used?",
      answer:
        "They are ideal for pictures, decorations, and lightweight shelves."
    },
    {
      question: "Do they leave marks?",
      answer:
        "No, they can be removed without leaving permanent holes."
    },
    {
      question: "Are they durable?",
      answer:
        "Yes, they provide strong and reliable holding power."
    },
    {
      question: "Are they easy to install?",
      answer:
        "Yes, they can be easily installed without special tools."
    }
  ]
},


 {
  code: "7130",
  name: "MAGNET CATCHER",
  category: "drawer fitting",

  short:
    "Magnet Catcher is a reliable cabinet accessory designed to keep doors securely closed using a strong magnetic mechanism. It ensures smooth and silent operation while preventing unwanted openings. Ideal for modular kitchens, wardrobes, and furniture, it offers durability and consistent performance.",

  features: [
    "Strong magnetic mechanism for secure closing",
    "Prevents accidental door opening",
    "Smooth and silent operation",
    "Durable and long-lasting construction",
    "Ideal for cabinets, wardrobes, and furniture",
    "Easy to install with standard fittings"
  ],

  /* ✅ PRICE */
  price: "₹20",
  oldPrice: "₹60",

  /* ✅ SKU + STOCK */
  sku: "7748",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgseven,
  thumbnails: [thumb15, thumb16],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/9191919650100908?text=Magnet%20Catcher%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal + Magnet" },
    { label: "Type", value: "Magnetic Catch" },
    { label: "Finish", value: "Standard" },
    { label: "Application", value: "Cabinet / Door Fitting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Magnet Catcher", code: "7748", size: "M2", finish: "" },
      { item: "Magnet Catcher", code: "7749", size: "M3", finish: "" },
        { item: "Magnet Catcher", code: "7750", size: "D5", finish: "" },
          { item: "Magnet Catcher", code: "7751", size: "C2", finish: "" },
            { item: "Magnet Catcher", code: "7752", size: "C3", finish: "" },

  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Magnet Catcher?",
      answer:
        "It is a magnetic device used to keep cabinet doors securely closed."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for cabinets, wardrobes, and modular furniture."
    },
    {
      question: "Does it prevent accidental opening?",
      answer:
        "Yes, it keeps doors closed until manually opened."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting use."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be installed easily using standard screws."
    }
  ]
},

  {
  code: "7131",
  name: "PREMIUM PVC PUSH CATCHER",
  category: "drawer fitting",

  short:
    "Premium PVC Push Catcher is a modern handle-less solution designed for smooth opening and closing of cabinets and drawers with a simple push. Made from high-quality PVC, it ensures reliable performance, silent operation, and a clean, minimal look for modular furniture.",

  features: [
    "Push-to-open mechanism for handle-less design",
    "Smooth and silent operation",
    "Made from durable high-quality PVC",
    "Ensures controlled opening and closing",
    "Ideal for cabinets, wardrobes, and furniture",
    "Easy to install with standard fittings"
  ],

  /* ✅ PRICE */
  price: "₹79",
  oldPrice: "₹90",

  /* ✅ SKU + STOCK */
  sku: "7772",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg8,
  thumbnails: [thumb17, thumb18],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/9191919650100908?text=Premium%20PVC%20Push%20Catcher%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC" },
    { label: "Type", value: "Push Catcher" },
    { label: "Finish", value: "Standard" },
    { label: "Application", value: "Cabinet / Drawer Fitting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "PVC Push Catcher", code: "7772", size: "", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Premium PVC Push Catcher?",
      answer:
        "It is a push mechanism that allows cabinets and drawers to open without handles."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is ideal for kitchens, wardrobes, and modular furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality PVC for long-lasting performance."
    },
    {
      question: "Does it provide smooth operation?",
      answer:
        "Yes, it ensures smooth and silent opening and closing."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed using standard fittings."
    }
  ]
},


  {
  code: "7132",
  name: "HANGING BRACKET",
  category: "drawer fitting",

  short:
    "Hanging Bracket is a strong and reliable support accessory designed for securely mounting shelves, cabinets, and modular furniture on walls. Made from high-quality metal, it offers excellent load-bearing capacity and long-lasting stability, making it ideal for modern interiors.",

  features: [
    "High-quality metal construction for durability",
    "Provides strong and stable wall support",
    "Supports heavy load without bending",
    "Prevents sagging and misalignment",
    "Ideal for cabinets, shelves, and furniture",
    "Easy to install with standard fittings"
  ],

  /* ✅ PRICE */
  price: "₹102",
  oldPrice: "₹130",

  /* ✅ SKU + STOCK */
  sku: "7533",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg9,
  thumbnails: [thumb19, thumb20],

  /* ✅ VIDEO */
  video: "https://www.instagram.com/reel/DTzvVBlj4F0/embed",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/9191919650100908?text=Hanging%20Bracket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal" },
    { label: "Type", value: "Mounting Bracket" },
    { label: "Finish", value: "Standard" },
    { label: "Application", value: "Wall Mount / Cabinet Support" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Hanging Bracket", code: "7533", size: "Standard", finish: "Metal" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Hanging Bracket?",
      answer:
        "It is a metal bracket used to mount shelves and cabinets securely on walls."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for kitchens, wardrobes, offices, and modular furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality metal for long-lasting performance."
    },
    {
      question: "Does it provide stable support?",
      answer:
        "Yes, it ensures strong load-bearing capacity and stability."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be installed easily using standard screws."
    }
  ]
},

 {
  code: "7133",
  name: "SHELF SCREW PIN",
  category: "drawer fitting",

  short:
    "Shelf Screw Pin is a reliable fastening accessory designed to securely support shelves in cabinets, wardrobes, and modular furniture. Made from high-quality metal, it ensures strong stability, proper alignment, and long-lasting performance.",

  features: [
    "Made from high-quality durable metal",
    "Provides strong and stable shelf support",
    "Ensures proper alignment and structure",
    "Ideal for cabinets, wardrobes, and furniture",
    "Long-lasting and reliable performance",
    "Easy to install with standard fittings"
  ],

  /* ✅ PRICE */
  price: "₹",
  oldPrice: "₹10",

  /* ✅ SKU + STOCK */
  sku: "7664",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg10,
  thumbnails: [thumb21, thumb22],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/sjUL5YzgSVU",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/9191919650100908?text=Shelf%20Screw%20Pin%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal" },
    { label: "Type", value: "Shelf Pin" },
    { label: "Finish", value: "Zinc / Steel" },
    { label: "Application", value: "Cabinet / Shelf Support" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Shelf Screw Pin", code: "7664", size: "Standard", finish: "Metal" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Shelf Screw Pin?",
      answer: "It is used to support shelves securely in cabinets and furniture."
    },
    {
      question: "Where can it be used?",
      answer: "It is ideal for kitchens, wardrobes, and modular furniture."
    },
    {
      question: "Is it durable?",
      answer: "Yes, it is made from high-quality metal."
    },
    {
      question: "Does it maintain alignment?",
      answer: "Yes, it ensures proper shelf alignment."
    },
    {
      question: "Is it easy to install?",
      answer: "Yes, it can be installed easily."
    }
  ]
},

 {
  code: "7134",
  name: "ANTI SLIP MAT GREY",
  category: "drawer fitting",

  short:
    "Anti Slip Mat Grey is a practical kitchen accessory designed to keep utensils and items stable inside drawers and cabinets. It prevents slipping, protects surfaces from scratches, and maintains a clean and organized storage space. Ideal for modular kitchens and furniture.",

  features: [
    "Anti-slip surface prevents movement of items",
    "Protects drawers and shelves from scratches",
    "Durable and flexible material",
    "Easy to clean and maintain",
    "Modern grey finish for stylish look",
    "Can be cut to fit any drawer size"
  ],

  /* ✅ PRICE */
  price: "₹2925",
  oldPrice: "₹3000",

  /* ✅ SKU + STOCK */
  sku: "7661",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg11,
  thumbnails: [thumb23, thumb24],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/9191919650100908?text=Anti%20Slip%20Mat%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC / Rubber" },
    { label: "Type", value: "Anti Slip Mat" },
    { label: "Color", value: "Grey" },
    { label: "Application", value: "Drawer / Shelf Protection" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Anti Slip Mat", code: "7661", size: "20m x 500mm x 0.8mm", finish: "Grey" },
    { item: "Anti Slip Mat", code: "7058", size: "20m x 500mm x 1mm", finish: "Grey" },
    { item: "Anti Slip Mat", code: "7662", size: "5m x 500mm x 1mm", finish: "Grey" },
    { item: "Anti Slip Mat", code: "7663", size: "20m x 500mm x 1mm", finish: "Grey" },

  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is the purpose of an Anti Slip Mat?",
      answer:
        "It prevents items from sliding and keeps drawers organized."
    },
    {
      question: "Can it be cut to size?",
      answer:
        "Yes, it can be easily trimmed to fit any drawer or shelf."
    },
    {
      question: "Is it easy to clean?",
      answer:
        "Yes, it can be cleaned with a damp cloth or water."
    },
    {
      question: "Where can it be used?",
      answer:
        "It can be used in drawers, shelves, cabinets, and wardrobes."
    },
    {
      question: "Does the color fade?",
      answer:
        "No, it is designed for long-term use without fading."
    }
  ]
},




  {
  code: "7138",
  name: "PUSH CATCHER SS BIG",
  category: "drawer fitting",

  short:
    "Push Catcher SS Big is a premium stainless steel push-to-open mechanism designed for handle-less cabinets and drawers. It offers strong performance, smooth operation, and enhanced durability, making it ideal for heavy-duty modular furniture applications.",

  features: [
    "Push-to-open mechanism for handle-less design",
    "Strong stainless steel body for durability",
    "Smooth and silent operation",
    "Suitable for heavy cabinets and drawers",
    "Ensures controlled opening and closing",
    "Easy to install with standard fittings"
  ],

  /* ✅ PRICE */
  price: "₹45",
  oldPrice: "₹90",

  /* ✅ SKU + STOCK */
  sku: "7532",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg12,
  thumbnails: [thumb25, thumb26],

  /* ✅ VIDEO */
  video: "https://www.instagram.com/reel/DXvhPruA5eP/embed",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/9191919650100908?text=Push%20Catcher%20SS%20Big%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel (SS)" },
    { label: "Type", value: "Push Catcher" },
    { label: "Size", value: "Big" },
    { label: "Application", value: "Cabinet / Drawer Fitting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Push Catcher SS Big", code: "7532", size: "Big", finish: "SS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Push Catcher SS Big?",
      answer:
        "It is a stainless steel push mechanism used for handle-less cabinet opening."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is ideal for modular kitchens, wardrobes, and heavy furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from stainless steel for long-lasting performance."
    },
    {
      question: "Does it support heavy doors?",
      answer:
        "Yes, the SS Big design is suitable for heavier cabinets and drawers."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed using standard fittings."
    }
  ]
},
{
  code: "7139",
  name: "PUSH CATCHER SS BIG",
  category: "drawer fitting",

  short:
  "Magnet Catcher M2 is a high-quality magnetic cabinet catcher designed for secure door closing and smooth functionality. It provides reliable magnetic holding strength, long-lasting durability, and easy installation, making it ideal for modular furniture and cabinet applications.",

features: [
  "Strong magnetic locking mechanism",
  "Durable body for long-lasting performance",
  "Smooth and secure door closing",
  "Suitable for cabinets and wardrobes",
  "Compact and reliable design",
  "Easy to install with standard fittings"
],

/* ✅ PRICE */
price: "₹35",
oldPrice: "₹70",

/* ✅ SKU + STOCK */
sku: "7748",
stock: "In Stock",

/* ✅ IMAGES */
mainImage: mainImg13,
thumbnails: [thumb27, thumb28],

/* ✅ VIDEO */
video: "https://www.youtube.com/embed/18ah0sc7Yz4",

/* ✅ LINKS */
catalogue: "/Slimline Price List-2026.pdf",
inquiry:
  "https://wa.me/91919650100908?text=Magnet%20Catcher%20M2%20Inquiry",

/* ✅ SPECIFICATIONS */
specifications: [
  { label: "Material", value: "Metal + Magnet" },
  { label: "Type", value: "Magnet Catcher" },
  { label: "Size", value: "M2" },
  { label: "Application", value: "Cabinet / Wardrobe Fitting" }
],

/* ✅ SPEC TABLE */
specTable: [
  { item: "Magnet Catcher M2", code: "7748", size: "M2", finish: "Standard" }
],

/* ✅ FAQ */
faq: [
  {
    question: "What is Magnet Catcher M2?",
    answer:
      "It is a magnetic catcher used for secure cabinet and wardrobe door closing."
  },
  {
    question: "Where can it be used?",
    answer:
      "It is suitable for modular kitchens, wardrobes, cabinets, and furniture."
  },
  {
    question: "Is it durable?",
    answer:
      "Yes, it is made with high-quality materials for long-lasting use."
  },
  {
    question: "Does it provide strong holding?",
    answer:
      "Yes, the magnetic mechanism ensures firm and secure closing."
  },
  {
    question: "Is it easy to install?",
    answer:
      "Yes, it can be easily installed using standard screws and fittings."
  }
]
},
{
  code: "7140",
  name: "HINGE LAMP",
  category: "drawer fitting",

  short:
    "Hinge Lamp is a smart cabinet lighting solution designed to provide automatic illumination inside wardrobes, cabinets, and kitchen units. It offers energy-efficient performance, easy installation, and convenient operation with cabinet hinges.",

  features: [
    "Automatic light activation on door opening",
    "Compact and modern design",
    "Energy-efficient LED lighting",
    "Easy installation with cabinet hinges",
    "Suitable for wardrobes and kitchen cabinets",
    "Provides bright and clear visibility"
  ],

  /* ✅ PRICE */
  price: "₹85",
  oldPrice: "₹170",

  /* ✅ SKU + STOCK */
  sku: "7721",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg14,
  thumbnails: [thumb29, thumb30],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/vy9BwPTrRY0",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91919650100908?text=Hinge%20Lamp%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "ABS + LED" },
    { label: "Type", value: "Hinge Lamp" },
    { label: "Power Source", value: "Battery Operated" },
    { label: "Application", value: "Wardrobe / Cabinet Lighting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Hinge Lamp", code: "7721", size: "Standard", finish: "Grey" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Hinge Lamp?",
      answer:
        "It is an automatic LED light attached to cabinet hinges for interior lighting."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is ideal for wardrobes, kitchen cabinets, drawers, and storage units."
    },
    {
      question: "Does it turn on automatically?",
      answer:
        "Yes, the light activates automatically when the cabinet door is opened."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be easily installed with standard cabinet hinges."
    },
    {
      question: "Is it energy efficient?",
      answer:
        "Yes, it uses low-power LED technology for efficient performance."
    }
  ]
},

];
